module.exports = __webpack_public_path__ + "img/katarina_bedrooms_18.e04eed01.jpg";